















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class HomeTile extends Vue {
  @Prop() private title!: string
  @Prop() private icon!: string
  @Prop() private route!: string

  private image: string = ''

  private mounted () {
    this.image = require('@/assets/icons/' + this.icon)
  }
}
